import { CONFIG } from '../../Config/config'

/**
 * API client to communicate with OPPIZI Dashboard API
 */
class APIDashboardsClient {
  /**
   * API Dashboards Path
   * @type Object
   */
  path = {
    campaign: {
      dashboards: {
        data: '/campaign/dashboards/data',
      },
    },
  }

  /**
   * Fetch Campaign Card Dashboard Data
   * @param {string} campaignId - The ID of the campaign
   * @returns {Promise<Object>} The dashboard data as JSON
   */
  fetchCampaignCardDashboardData = async campaignId => {
    const url = `${CONFIG.API_DASHBOARDS_BASE_URL}${
      this.path.campaign.dashboards.data
    }/${campaignId}`

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      mode: 'cors',
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return await response.json()
  }
}

export const apiDashboardsClient = new APIDashboardsClient()
